import { render, staticRenderFns } from "./KasProduksiFiberForm.vue?vue&type=template&id=ccd59ad6"
import script from "./KasProduksiFiberForm.vue?vue&type=script&lang=js"
export * from "./KasProduksiFiberForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports